import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import createPersistedStateIndexedDB from 'vuex-persist-indexeddb';
import currentUser from './modules/currentUser';
import general from './modules/general';
import productTypeSettings from './modules/productTypeSettings';
import printers from './modules/printers';
import stockcount from './modules/stockcount';
import semiFinishedProductOverview from './modules/semiFinishedProductOverview';
import semiFinishedProductDeliverOverview from './modules/semiFinishedProductDeliverOverview';
import deliveryDates from './modules/deliveryDates';
import colorOverview from './modules/colorOverview';
import canvasOverview from './modules/canvasOverview';
import orderLineOverview from './modules/orderLineOverview';
import productEditOverview from './modules/productEditOverview';
import pleatingOverview from './modules/pleatingOverview';
import canvasWorkOverview from './modules/canvasWorkOverview';
import profileOrderHistoryTable from './modules/profileOrderHistoryTable';
import articles from './modules/articles';
import timeline from './modules/timeline';
import dateModal from './modules/dateModal';
import newOrders from './modules/newOrders';
import productOverviews from './modules/productOverviews';
import sawlines from './modules/sawlines';
import appSettings from './modules/appSettings';
import productTypesCache from './modules/productTypesCache';
import editProduct from './modules/editProduct';
import localization from './modules/localization';
import productTypeGroups from './modules/productTypeGroups';
import interactiveProductFlows from './modules/interactiveProductFlows';
import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex);

// Persist store
const vuexLocal = createPersistedState({
    paths: [
        'printers.selectedPrinters',
        'stockcount',
        'semiFinishedProductOverview.filters',
        'semiFinishedProductDeliverOverview.filters',
        'deliveryDates.filters',
        'deliveryDates.offsetClicked',
        'colorOverview.filters',
        'canvasOverview.filters',
        'orderLineOverview.filters',
        'productEditOverview.filters',
        'pleatingOverview.filters',
        'canvasWorkOverview.filters',
        'profileOrderHistoryTable.filters',
        'newOrders.filters',
        'productOverviews.filters',
        'appSettings',
        'interactiveProductFlows.activeFlows',
    ],
});

const vuexLocalDontClear = createPersistedStateIndexedDB({
    key: 'vuexPermanent',
    paths: ['productTypesCache'],
});

const vuexSession = createPersistedState({
    storage: window.sessionStorage,
    paths: [
        'currentUser.sessionKeys',
        'currentUser.apiCredentials',
        'currentUser.rankedTypes',
        'currentUser.rights',
        'currentUser.userId',
        'currentUser.name',
        'currentUser.userName',
        'currentUser.type',
        'currentUser.userLocation',
        'currentUser.qrScanner.cameraTypes',
        'editProduct.orderId',
        'editProduct.orderedItems',
        'general.runningTasks',
    ],
});

// Create store
window.vuexStore = new Vuex.Store({
    modules: {
        currentUser,
        general,
        printers,
        productTypeSettings,
        stockcount,
        semiFinishedProductOverview,
        semiFinishedProductDeliverOverview,
        deliveryDates,
        colorOverview,
        canvasOverview,
        orderLineOverview,
        productEditOverview,
        pleatingOverview,
        canvasWorkOverview,
        profileOrderHistoryTable,
        articles,
        timeline,
        dateModal,
        newOrders,
        productOverviews,
        sawlines,
        appSettings,
        productTypesCache,
        editProduct,
        localization,
        productTypeGroups,
        interactiveProductFlows,
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
    },
    plugins: [vuexLocal, vuexSession, vuexLocalDontClear],
});

export default window.vuexStore;
